import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_SafetyPlan = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_SafetyPlan' className='file-pdf-document'>

            <div className='file-template'>

                <p>
                    I <input type="text" name="txtName" id="txtName" className='add-only w-250 custom-add-only' />, agree to enter into a safety plan with (Staff Name)
                    <input type="text" name="txtStaffName" id="txtStaffName" className='add-only w-250 custom-add-only' /> of New Heights Behavioral Consultants effective today
                    (Date)
                    <input type="date" name="txtDate" id="txtDate" className='add-only  w-250 custom-add-only' /> and will utilize this safety plan if I am feeling overwhelmed, angry, depressed, upset, or in
                    a state of crisis. I agree to use the below listed coping skills and resources to address all potentially dangerous
                    behaviors.
                </p>
                <h3>SAFETY CONCERN #1-MENTAL HEALTH</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>SUICIDAL IDEATION</span>
                            <input type="text" name="txtSuicidalIdeation" id="txtSuicidalIdeation" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>SUCIIDAL ATTEMPTS</span>
                            <input type="text" name="txtSuicidalAttempts" id="txtSuicidalAttempts" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>HOMICIDAL IDEATION</span>
                            <input type="text" name="txtHomicidalIdeation" id="txtHomicidalIdeation" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>HOMICIDAL ATTEMPTS</span>
                            <input type="text" name="txtHomicidalAttempts" id="txtHomicidalAttempts" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DEPRESSION/DEPRESSED MOOD</span>
                            <input type="text" name="txtDepression" id="txtDepression" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ANXIETY</span>
                            <input type="text" name="txtAnxiety" id="txtAnxiety" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>ANGER</span>
                            <input type="text" name="txtAnger" id="txtAnger" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ODD</span>
                            <input type="text" name="txtOdd" id="txtOdd" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>ADD/ADHD</span>
                            <input type="text" name="txtAdd" id="txtAdd" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>SPMI/Schizophrenia</span>
                            <input type="text" name="txtSchizophrenia" id="txtSchizophrenia" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>SAFETY CONCERN # 2-BEHAVIORS</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>FIGHTING</span>
                            <input type="text" name="txtFighting" id="txtFighting" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>SUBSTANCE ABUSE</span>
                            <input type="text" name="txtSubstanceAbuse" id="txtSubstanceAbuse" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>TRUANCY</span>
                            <input type="text" name="txtTruancy" id="txtTruancy" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>RUNNING AWAY</span>
                            <input type="text" name="txtRunningAway" id="txtRunningAway" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DISTRACTIBILITY/IMPULSIVITY</span>
                            <input type="text" name="txtImpulsivity" id="txtImpulsivity" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ISOLATION/WITHDRAWN</span>
                            <input type="text" name="txtIsolation" id="txtIsolation" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>PEER CONFLICT</span>
                            <input type="text" name="txtPeerConflict" id="txtPeerConflict" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ODD</span>
                            <input type="text" name="txtOdd1" id="txtOdd1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>SAFETY CONCERN # 3-TRIGGERS TO UNDESIRED BEHAVIORS</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>YELLING/ARGUING</span>
                            <input type="text" name="txtYelling" id="txtYelling" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PEER PRESSURE</span>
                            <input type="text" name="txtPeerPressure" id="txtPeerPressure" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>FEELING DISRESPECTED</span>
                            <input type="text" name="txtFeelingDisrespected" id="txtFeelingDisrespected" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>FEELING OVERWHELMED</span>
                            <input type="text" name="txtFeelingOverwhelmed" id="txtFeelingOverwhelmed" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>IMPULSIVITY</span>
                            <input type="text" name="txtImpulsivity1" id="txtImpulsivity1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ISOLATION/WITHDRAWN</span>
                            <input type="text" name="txtWithdrawn" id="txtWithdrawn" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>PEER CONFLICT</span>
                            <input type="text" name="txtPeerConflict1" id="txtPeerConflict1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>STRESS</span>
                            <input type="text" name="txtStress" id="txtStress" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>FAMILY STRESSORS/CONCERNS</span>
                            <input type="text" name="txtFamilyStressors" id="txtFamilyStressors" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <h3>COPING SKILLS:</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>LISTENING TO MUSIC</span>
                            <input type="text" name="txtListeningToMusic" id="txtListeningToMusic" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>WALKING AWAY</span>
                            <input type="text" name="txtWalkingAway" id="txtWalkingAway" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>TAKING A TIME OUT</span>
                            <input type="text" name="txtTimeOut" id="txtTimeOut" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>TALK TO SOMEONE YOU TRUST</span>
                            <input type="text" name="txtSomeoneYouTrust" id="txtSomeoneYouTrust" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>GYM/EXERCISE</span>
                            <input type="text" name="txtGym" id="txtGym" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ARTS/CRAFTS/DRAWING</span>
                            <input type="text" name="txtArts" id="txtArts" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>JOURNALING</span>
                            <input type="text" name="txtJournaling" id="txtJournaling" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DEEP BREATHING/COUNTING</span>
                            <input type="text" name="txtCounting" id="txtCounting" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>STOP, THINK, ACT</span>
                            <input type="text" name="txtThink" id="txtThink" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    If I feel overwhelmed, depressed, angry or that I want to harm myself or someone else, I will call people I
                    trust, professionals or agencies that can help me to prevent or during a crisis:
                </p>
                <p>
                    <strong>People I trust:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span>
                            <input type="text" name="txtNamePeopleTrust" id="txtNamePeopleTrust" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                            <input type="text" name="txtRelationship" id="txtRelationship" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtPhone" id="txtPhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span>
                            <input type="text" name="txtName1" id="txtName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                            <input type="text" name="txtRelationship1" id="txtRelationship1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtPhone1" id="txtPhone1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Professionals to call:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1.Therapist</span>
                            <input type="text" name="txtTherapist" id="txtTherapist" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtPhone2" id="txtPhone2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>2.Paraprofessional</span>
                            <input type="text" name="txtParaprofessional" id="txtParaprofessional" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtPhone3" id="txtPhone3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3.Other:</span>
                            <input type="text" name="txtOtherProfessionals" id="txtOtherProfessionals" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span>
                            <input type="text" name="txtPhone4" id="txtPhone4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    4.Suicide Prevention Lifeline Phone: 1-800-273-TALK (8255)
                </p>
                <p>
                    5. Georgia Crisis & Access Line (BHL): 1-800-715-4225
                </p>
                <p>
                    <strong>If I complete these steps and still want to harm myself or someone else, I will call 9-1-1 for help</strong>
                </p>
                <table>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Client's Signature:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Parent/Guardian Signature:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Therapist Printed Name/ Credentials:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Therapist Signature:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-550'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Paraprofessional Signature:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                </table>


            </div>
        </form>

    )
} 
